var map = {
	"./de/warrior-name.png": "n5FV",
	"./en/warrior-name.png": "dxOK",
	"./es/warrior-name.png": "rlUS",
	"./fr/warrior-name.png": "2hSH",
	"./ja/warrior-name.png": "nsYl",
	"./ko/warrior-name.png": "8Ib4",
	"./pt/warrior-name.png": "qGkZ",
	"./ru/warrior-name.png": "njm2",
	"./th/warrior-name.png": "ORjN",
	"./zh-Hant/warrior-name.png": "ibLW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fjfm";